import { getPublicSettings } from '@/lib/api'
import { SUPPORTED_LOCALES, type Locale } from '@/i18n/config'

/** Module-level so every consumer shares one settings fetch per page. */
let activePromise: Promise<Locale[]> | null = null

/**
 * The admin-activated locale set, fail-open: an unreachable settings
 * endpoint must not hide languages.
 */
export function fetchActiveLocales(): Promise<Locale[]> {
  activePromise ??= getPublicSettings()
    .then((s) => SUPPORTED_LOCALES.filter((l) => s.activeLocales.includes(l)))
    .catch(() => {
      activePromise = null // allow a retry on the next mount
      return [...SUPPORTED_LOCALES]
    })
  return activePromise
}
